/**
 * MetricCard — one of the 5 clickable cards on the Dashboard.
 *
 * Each card opens a modal with the underlying candidate list. The colour and badge
 * are passed as props so callers can use the existing palette (#93C5FD, #C4B5FD, etc.).
 */
export const MetricCard = ({
  testId,
  onClick,
  bgColor,
  icon: Icon,
  badge,
  count,
  label,
  hint = 'Click to view list',
}) => (
  <button
    data-testid={testId}
    onClick={onClick}
    className={`${bgColor} border-2 border-[#0A0A0A] rounded-md shadow-[4px_4px_0px_0px_rgba(163,230,53,0.5)] hover:shadow-[6px_6px_0px_0px_rgba(163,230,53,0.7)] hover:-translate-y-1 transition-all p-6 text-[#0A0A0A] text-left cursor-pointer`}
  >
    <div className="flex items-start justify-between mb-4">
      <Icon size={32} weight="duotone" />
      {badge}
    </div>
    <div className="text-3xl font-black mb-1">{count}</div>
    <div className="text-xs font-bold uppercase tracking-wider">{label}</div>
    <div className="text-xs text-black mt-2 font-medium">{hint}</div>
  </button>
);
